<template>
    <div class="section"> 
        <b-loading :is-full-page="false" :active.sync="generalLoading" :can-cancel="true"></b-loading>
        <div class="columns is-variable is-3-desktop is-4-widescreen is-2-fullhd">
            <!--Cart-->
            <div class="column is-one-third ">
                <h1 class="title has-text-centered">Tu pedido</h1>
                <ShoppingList
                :noDataIll="noDataIll"
                :loadingCart="loadingCart"
                :cart="cart"
                :cartItemDetailUrl="cartItemDetailUrl"
                :userProfile="userProfile"
                :userEmail="userEmail"
                @removeCartItem="fetchCartDetails"
                @savedOrder="postOrder"
                />
            </div>

            <!--Product List-->
            <div class="column is-two-thirds ">
                <h1 class="title has-text-centered">Productos</h1>
                <ProductListItem
                :notFound="notFound"
                :loadingList="loadingProdList"
                :items="products"
                :prodDetailUrl="prodDetailUrl"
                :createCartItemUrl="createCartItemUrl"
                :subcategoryList="subcategoryList"
                :categoryList="categoryList"
                @refreshProdList="updateSearchParams"
                @addedItemToCart="fetchCartDetails"
                />
                <b-pagination
                    v-if="products.length"
                    :total="count"
                    :per-page="perPage"
                    :current.sync="page"
                    :range-before="2"
                    :rounded="true"
                    :range-after="2"
                    order="is-centered"
                    @change="onPageChange"
                    icon-prev="chevron-left"
                    icon-next="chevron-right"
                >
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import ShoppingList from './components/ShoppingList'
import ProductListItem from './components/ProductListItem'
import { getHandler, postHandler, debounce } from '../../../services/http'
export default {
    components:{
        ProductListItem,
        ShoppingList
    },
    props:{
        productsUrl:{
            type:String,
            default:""
        },
        prodDetailUrl:{
            type:String,
            default:""
        },
        createCartItemUrl:{
            type:String,
            default:""
        },
        cartDetailUrl:{
            type:String,
            default:""
        },
        cartDetailUrl:{
            type:String,
            default:""
        },
        cartItemDetailUrl:{
            type:String,
            default:""
        },
        noDataIll:{
            type:String,
            default:""
        },
        profileEndpoint:{
            type:String,
            default:""
        },
        createOrder:{
            type:String,
            default:""
        },
        userEmail:{
            type:String,
            default:""
        },
        userSettings:{
            type:String,
            default:""
        },
        categoryListEndpoint:{
            type:String,
            default:""
        },
        subcategoryListEndpoint:{
            type:String,
            default:""
        },
        notFound:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            loadingProdList:false,
            products:[],
            perPage:24,
            count:0,
            page:1,

            loadingCart:false,
            cart:{},
            order:{},
            orderData:{},
            payment:{
                method:'transfer'
            },
            userProfile:{},
            generalLoading:false,
            subcategoryList:[],
            categoryList:[],
            searchQ:"",
            categoryQ:"",
            subcategoryQ:""
        }
    },
    methods:{
        async fetchProducts(){
            this.loadingProdList = true
            let url = `${this.productsUrl}?public_only=true&page=${this.page}&search=${this.searchQ}`
            if (this.categoryQ){
                url = url + `&cat_slug=${this.categoryQ.slug}`
            }
            if (this.subcategoryQ){
                url = url + `&sub_slug=${this.subcategoryQ.slug}`
            }
            var response = await getHandler(url, {error:false, success:false})
            this.loadingProdList = false
            this.cart = response
            this.count = response.count
            this.products = response.results
            console.log("productos en general", this.products)
        },
        async fetchCartDetails(){
            this.loadingCart = true
            var response = await getHandler(this.cartDetailUrl, {error:false, success:false})
            this.cart = response
            this.order['cart'] = this.cart.id
            this.payment['amountUy'] = this.cart.totalInUy 
            this.payment['amountUsd'] = this.cart.totalInUsd
            this.loadingCart = false
            console.log('cart response', response)
        },
        onPageChange(page){
            this.page = page
            this.fetchProducts()
        },
        async fetchUserProfile(){
            this.userProfile = await getHandler(this.profileEndpoint, {error:false, success:false})
        },
        async postOrder(data){
            this.generalLoading = true
            this.orderData = data
            var success = {
                resource:'notify',
                text:'Listo! orden creada con exito!'
            }
            var error = {
                resource:'notify',
                text:'No se pudo crear la orden, revisa los datos e intentalo otra vez.'
            }
            var orderReqBody = {
                order:this.order,
                orderData:this.orderData,
                payment:this.payment,
            }
            let resp = await postHandler(this.createOrder, orderReqBody, {success, error})
            this.generalLoading = false
            if (resp.status == 200 || resp.status == 201){
                localStorage.setItem("cartCount", 0)
                var event = document.createEvent("Event");
                event.initEvent("storage", true, true);
                window.dispatchEvent(event);
                window.location.href = this.userSettings
            }
        },
        async fetchSubCategories(){
            let url = `${ this.subcategoryListEndpoint}?page=1`
            let response = await getHandler(url, {success:false, error:false})
            this.subcategoryList = response.results
            console.log("subcategories", this.subcategoryList)
        },
        async fetchCategories(){
            let response = await getHandler(this.categoryListEndpoint, {success:false, error:false})
            this.categoryList = response
        },
        updateSearchParams: debounce(function(data){
            this.categoryQ = data.categoryQ
            this.subcategoryQ = data.subcategoryQ
            this.searchQ = data.searchQ
            this.page = 1
            this.fetchProducts()
        }, 500)
    },
    created(){
        this.fetchProducts()
        this.fetchCartDetails()
        this.fetchUserProfile()
        this.fetchCategories()
        this.fetchSubCategories()
    }
}
</script>

<style lang="scss" scoped>


.column-style{
    border-radius: 20px;
    box-shadow: 1px 10px 10px rgba(184, 184, 184, 0.55);
}

</style>